module.exports = __webpack_public_path__ + "static/img/小程序二维码@2x.ee7378b.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/asideMenu/小程序二维码@2x.png
// module id = 034O
// module chunks = 88